import { CwtApiSchema, CwtModel, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { EvaluationResultEntity } from "./eval-result.entity";
import { QuestionAnswer } from "./question-eval.model";

@CwtSchema()
export class EvalSleepStopbangResult extends CwtApiSchema {
    // STOP
    @CwtProp() isSnoringLoudly: boolean;
    @CwtProp() isOftenTiredDuringDay: boolean;
    @CwtProp() hasObservedBreathingPause: boolean;
    @CwtProp() hasHighBloodPressure: boolean;
    // BANG
    @CwtProp() hasHighBmi: boolean;
    @CwtProp() isOlderAge: boolean;
    @CwtProp() hasLargeNeck: boolean;
    @CwtProp() isMale: boolean;
}

@CwtModel({ name: 'eval-sleep' })
export class EvalSleep extends EvaluationResultEntity {
    // 0-100 score
    @CwtProp() isiScore: number;
    @CwtProp() fordScore: number;
    @CwtProp() stopbangScore: number;
    @CwtProp() completedSurveys: string[];
    // raw scores 
    @CwtProp() isiAnswerScore: number;
    @CwtProp() fordAnswerScore: number;
    @CwtProp() stopAnswerScore: number;
    @CwtProp() bangAnswerScore: number;
    @CwtProp() stopbangAnswerScore: number;
    // eval results
    @CwtProp({ ref: QuestionAnswer }) isiResult: QuestionAnswer[];
    @CwtProp({ ref: QuestionAnswer }) fordResult: QuestionAnswer[];
    @CwtProp({ ref: EvalSleepStopbangResult }) stopbangResult: EvalSleepStopbangResult;

    public get includesIsi() { return this.completedSurveys?.includes('isi'); }
    public get includesFord() { return this.completedSurveys?.includes('ford'); }
    public get includesStopbang() { return this.completedSurveys?.includes('stopbang'); }
}